import { Box, Card, CardContent, Divider, Grid, Skeleton, Stack } from "@mui/material";
import AppLayout from "@/components/AppLayout";
import Block from "@/components/Block";
import BookingProgressIndicator from "@/features/booking/components/BookingProgressIndicator";

export default function SearchLayoutSkeleton() {
  const renderCampsiteCardSkeleton = () => (
    <Card sx={{ display: "flex", flexDirection: "column", border: 1, borderColor: "divider" }}>
      {/* Top section: image + content */}
      <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" } }}>
        <Box
          sx={{
            width: { xs: "100%", sm: 220 },
            aspectRatio: { xs: "16 / 9", sm: "1 / 1" },
            flexShrink: 0,
            bgcolor: "grey.300",
            m: { sm: 2 },
            borderRadius: { sm: 2 },
            overflow: "hidden",
          }}
        >
          <Skeleton variant="rectangular" width="100%" height="100%" />
        </Box>
        <CardContent sx={{ flex: 1 }}>
          <Stack spacing={1}>
            <Skeleton variant="text" width="70%" height={32} />
            <Skeleton variant="text" width="90%" height={20} />
            <Skeleton variant="text" width="80%" height={20} />
            <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
              <Skeleton variant="rounded" width={80} height={28} />
              <Skeleton variant="rounded" width={80} height={28} />
            </Stack>
          </Stack>
        </CardContent>
      </Box>

      {/* Desktop: divider + price (left) + button (right) */}
      <Divider sx={{ mx: 2, display: { xs: "none", sm: "block" } }} />
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ px: 2, py: 1.5, display: { xs: "none", sm: "flex" } }}
      >
        <Stack spacing={0.5}>
          <Skeleton variant="text" width={120} height={18} />
          <Skeleton variant="text" width={80} height={28} />
        </Stack>
        <Skeleton variant="rounded" width={140} height={52} sx={{ borderRadius: 8 }} />
      </Stack>

      {/* Mobile: full-width button */}
      <Box sx={{ p: 2, display: { xs: "block", sm: "none" } }}>
        <Skeleton variant="rounded" width="100%" height={52} sx={{ borderRadius: 8 }} />
      </Box>
    </Card>
  );

  const renderBookingSearchDetailsSkeleton = () => (
    <Block sx={{ display: { xs: "block", sm: "none" } }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Stack direction="row" spacing={1} flex={1} sx={{ minWidth: 0, overflow: "hidden" }}>
          <Skeleton variant="text" width="30%" height={20} sx={{ flexShrink: 0 }} />
          <Skeleton variant="text" width="40%" height={20} sx={{ flexShrink: 1, minWidth: 0 }} />
          <Skeleton variant="text" width="30%" height={20} sx={{ flexShrink: 1, minWidth: 0 }} />
        </Stack>
        <Skeleton variant="circular" width={28} height={28} sx={{ ml: 1, flexShrink: 0 }} />
      </Box>
    </Block>
  );

  const renderBookingSummarySkeleton = () => (
    <Block
      sx={{ p: "13px", height: "fit-content", border: 0, display: { xs: "none", sm: "block" } }}
    >
      <Stack spacing={2}>
        <Box sx={{ width: "100%" }}>
          <Skeleton variant="text" width="60%" height={30} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="50%" height={18} />
          <Skeleton variant="text" width="40%" height={18} />
          <Skeleton variant="text" width="40%" height={18} />
        </Box>
        <Divider />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ width: "100%" }}>
            <Skeleton variant="text" width="40%" height={18} />
            <Skeleton variant="text" width="40%" height={18} />
            <Skeleton variant="text" width="20%" height={18} />
          </Box>
          <Skeleton variant="text" width={100} height={24} />
        </Box>
      </Stack>
    </Block>
  );

  return (
    <AppLayout title={<BookingProgressIndicator />}>
      <Grid container spacing={{ xs: 1, sm: 3 }} p={2}>
        <Grid size={{ xs: 12, sm: 4 }}>
          {renderBookingSearchDetailsSkeleton()}
          {renderBookingSummarySkeleton()}
        </Grid>
        <Grid size={{ xs: 12, sm: 8 }}>
          <Stack spacing={3}>
            {renderCampsiteCardSkeleton()}
            {renderCampsiteCardSkeleton()}
            {renderCampsiteCardSkeleton()}
          </Stack>
        </Grid>
      </Grid>
    </AppLayout>
  );
}
